import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageTemplate } from '@/components/templates'
import { CONTAINER_SIZES } from '@/constants'
import OrderbookTable from '@/components/orderbook/OrderbookTable'
import { useOTC } from '@/hooks/useOTC'
import { useOtcStats } from '@/hooks/useOTC'
import { OTCMetricsCards } from '@/components/molecules/OTCMetricsCards'

const OTCScreen: React.FC = () => {
  const navigate = useNavigate()
  const { data: stats, loading: statsLoading } = useOtcStats()
  const [countdown, setCountdown] = useState(20)

  // Countdown timer for data refresh
  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) return 20
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <PageTemplate
      maxWidth={CONTAINER_SIZES.WIDE}
    >
      <div className="space-y-4">
        {/* Header Section */}
        <div className="mb-8">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <h1 
                className="text-[#2D2923] dark:text-[#FDFDFD] text-[30px] leading-[40px] font-semibold tracking-[-0.28px] mb-1"
                style={{ fontFeatureSettings: "'liga' off, 'clig' off" }}
              >
                OTC Trading
              </h1>
              <p 
                className="text-[rgba(45,41,35,0.64)] dark:text-[#FDFDFDA3] text-[16px] leading-[24px] font-normal"
                style={{ fontFeatureSettings: "'liga' off, 'clig' off" }}
              >
                Over-the-counter trading with institutional liquidity
              </p>
            </div>
            <div className="text-sm text-[rgba(45,41,35,0.64)] dark:text-[#FDFDFDA3] ml-4 mt-2 flex-shrink-0 font-medium">
              Next update: {countdown}s
            </div>
          </div>
        </div>

        {/* Metrics Cards */}
        <OTCMetricsCards 
          stats={stats} 
          loading={statsLoading}
        />
        
        {/* Orders Table */}
        <OrderbookTable
          title="OTC Orders"
          navigate={navigate}
          useDataHook={useOTC}
          dataKey="orders"
          showPagination={true}
          useUrlParams={true}
          showOrderInquiry={true}
        />
      </div>
    </PageTemplate>
  )
}

export default OTCScreen 